define('areas/informationrequest/service/informationrequest-service',["require", "exports", "areas/informationrequest/models/bindable", "./dataCollectionClient"], function (require, exports, VM, DCHttpClient) {
    "use strict";
    var InformationRequestService = (function () {
        function InformationRequestService() {
            this.saveCommentLink = "api/comment/create/";
            this.saveClientDetailsLink = "api/inforequest/Put";
            this.getClientsLink = "api/inforequest/Get/";
            this.getTaxYearListLink = "api/taxyear/Get/";
            this.checkHmrcTokenLink = "api/hmrc/hasValidUserToken/";
            this.postHmrcDataLink = "api/HmrcData/Refresh/";
            this.getAttachmentLink = "api/attachment/Get/";
            this.getCommentsLink = "api/comment/get/";
            this.clearNotificationLink = "api/section/clear-notification/";
            this.saveSpouseInfoLink = "api/inforequest/PutSpouse/";
            this.commitToTaxLink = "api/commit/get/";
            this.uploadAttachmentLink = "api/attachment/";
            this.deleteAttachmentLink = "api/attachment/Delete/";
            this.getEmployeesListLink = "api/employee/Get/";
            this.getRequestStatusesLink = "api/requeststatus/Get/";
            this.postClientsFilteredByUserListLink = "api/taxyear/Post/";
            this.getReturnStatusLink = "api/inforequest/Get/";
            this.getRefreshInfoRequestLink = "api/inforequest/";
            this.getExportToPdf = "api/inforequest/exporttopdf/";
            this.postClientsFilteredByUser = "api/taxyear/exporttoexcel";
        }
        InformationRequestService.prototype.GetEmployeeById = function (id) {
            var service = new DCHttpClient.Channel();
            var url = id;
            return service.getDataAsync(this.getEmployeesListLink + url)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetEmployeesFiltered = function (skipCount, takeCount, searchInput) {
            var service = new DCHttpClient.Channel();
            var url = searchInput != "" ? skipCount + "/" + takeCount + "/" + searchInput : skipCount + "/" + takeCount + "/";
            return service.getDataAsync(this.getEmployeesListLink + url)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetAllRequestStauses = function () {
            var service = new DCHttpClient.Channel();
            return service.getDataAsync(this.getRequestStatusesLink)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetClientForUser = function (id, filterYears) {
            var service = new DCHttpClient.Channel();
            var url = id + "/" + filterYears;
            return service.getDataAsync(this.getTaxYearListLink + url)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetClients = function (skipCount, takeCount) {
            var service = new DCHttpClient.Channel();
            return service.getDataAsync(this.getTaxYearListLink + skipCount + "/" + takeCount)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetClientsSorted = function (skipCount, takeCount, sortColumn, sortCriteria, searchInput, filterYears) {
            var service = new DCHttpClient.Channel();
            var url = searchInput != "" ? skipCount + "/" + takeCount + "/" + sortColumn + "/" + sortCriteria + "/" + filterYears + "/" + searchInput : skipCount + "/" + takeCount + "/" + sortColumn + "/" + sortCriteria + "/" + filterYears;
            return service.getDataAsync(this.getTaxYearListLink + url)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetClientsSortedByUser = function (id, skipCount, takeCount, sortColumn, sortCriteria, searchInput, filterYears, selectedStatusId) {
            var url;
            var data = new VM.TaxYearParameters();
            data.skip = skipCount;
            data.take = takeCount;
            data.sortColumn = sortColumn;
            data.sortCriteria = sortCriteria;
            data.searchInput = searchInput;
            data.filterYears = filterYears;
            data.employeeFilter = id;
            data.requestStatusFilter = selectedStatusId;
            var service = new DCHttpClient.Channel();
            return service.postDataAsync(this.postClientsFilteredByUserListLink, data)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.CheckHmrcToken = function (clientGuid) {
            var service = new DCHttpClient.Channel();
            return service.getDataAsync(this.checkHmrcTokenLink + clientGuid)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.ExportToPdf = function (clientGuid, taxYear) {
            var service = new DCHttpClient.Channel();
            return service.getDataAsync(this.getExportToPdf + clientGuid + "/" + taxYear)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.ExportToExcel = function (id, skipCount, takeCount, sortColumn, sortCriteria, searchInput, filterYears, selectedStatusId) {
            var data = new VM.TaxYearParameters();
            data.skip = skipCount;
            data.take = takeCount;
            data.sortColumn = sortColumn;
            data.sortCriteria = sortCriteria;
            data.searchInput = searchInput;
            data.filterYears = filterYears;
            data.employeeFilter = id;
            data.requestStatusFilter = selectedStatusId;
            var service = new DCHttpClient.Channel();
            return service.postDataAsync(this.postClientsFilteredByUser, data)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetClientDetails = function (id, taxYear) {
            var service = new DCHttpClient.Channel();
            var path = this.getClientsLink + id + "/" + taxYear;
            return service.getDataAsync(path)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.GetReturnStatus = function (id, taxYear) {
            var service = new DCHttpClient.Channel();
            var path = this.getReturnStatusLink + id + "/" + taxYear + "/returnstatus";
            return service.getDataAsync(path);
        };
        InformationRequestService.prototype.SaveCommentAync = function (id, taxYear, comment) {
            var service = new DCHttpClient.Channel();
            var path = this.saveCommentLink + id + "/" + taxYear;
            return service.postDataAsync(path, (comment));
        };
        InformationRequestService.prototype.Refresh = function (clientGuid, utr, taxYear, spouseInfo) {
            var service = new DCHttpClient.Channel();
            var path = this.postHmrcDataLink + utr + "/" + taxYear + "/" + clientGuid;
            return service.postDataAsync(path, (spouseInfo), "CCHMakingTaxDigital");
        };
        InformationRequestService.prototype.SaveClientDetails = function (infoRequest) {
            var service = new DCHttpClient.Channel();
            return service.putDataAsync(this.saveClientDetailsLink, infoRequest);
        };
        InformationRequestService.prototype.CommitToTax = function (clientGuid, taxYear, sectionGuids, showNotification) {
            var service = new DCHttpClient.Channel();
            var path = this.commitToTaxLink + clientGuid + "/" + taxYear + "/";
            return service.postDataAsync(path, sectionGuids);
        };
        InformationRequestService.prototype.putDataAsync = function (link, infoRequest) {
            var service = new DCHttpClient.Channel();
            service.putDataAsync(link, (infoRequest));
        };
        InformationRequestService.prototype.getAttachment = function (guid) {
            var service = new DCHttpClient.Channel();
            return service.getDataAsync(this.getAttachmentLink + guid)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        InformationRequestService.prototype.uploadAttachment = function (file, clientGuid, taxYear, sectionGuid, blocksCount, blockId) {
            var service = new DCHttpClient.Channel();
            var path = this.uploadAttachmentLink + clientGuid + "/" + taxYear + "/" + sectionGuid + "/" + blocksCount + "/" + blockId;
            return service.postDataAsync(path, file);
        };
        InformationRequestService.prototype.deleteAttachment = function (attachmentGuid, taxYear, clientGuid, fileName, sectionGuid) {
            var service = new DCHttpClient.Channel();
            var path = this.deleteAttachmentLink + attachmentGuid + "/" + taxYear + "/" + clientGuid + "/" + fileName + "/" + sectionGuid;
            return service.deleteDataAsync(path);
        };
        InformationRequestService.prototype.getComments = function (guid) {
            var service = new DCHttpClient.Channel();
            return service.getDataAsync(this.getCommentsLink + guid)
                .then(function (response) {
                return response;
            })
                .fail(function (error) {
                return null;
            });
        };
        InformationRequestService.prototype.clearNotification = function (clientGuid, taxYear, sectionGuid) {
            var service = new DCHttpClient.Channel();
            var link = this.clearNotificationLink + clientGuid + '/' + taxYear + '/' + sectionGuid;
            return service.putDataAsync(link, null);
        };
        return InformationRequestService;
    }());
    exports.InformationRequestService = InformationRequestService;
});

